<template>
    <b-card
        :class="['list-container']"
        bg-variant="white"
        no-body
    >
        <template #header>
            <div class="d-flex align-items-center justify-content-between" style="height: 36px">
                <div >
                    <h6 class="mb-0">평가 참여 정보</h6>
                </div>
            </div>
        </template>
        <b-table :items="selected_company.projects"
                 :fields="companyRequestColumn"
                 :empty-html="getEmptyTableHTML"
                 :sticky-header="true"
                 class="mb-0 sticky-header-sort-fix custom-table"
                 show-empty
        >

            <template #empty="">
                <div class="h6 gray-500 font-weight-normal text-center mb-0 py-3">
                    참여중인 프로젝트가 없습니다.
                </div>
            </template>
            <template #cell(status_code)="data">
                <b-badge :variant="getProgressColor(data.item)" class="mr-2">
                    {{ getProgressStatus(data.item) }}
                </b-badge>
            </template>

            <template #cell(member)="data">
                <b-button size="sm" variant="dark-border"
                          @click="manageProjectMember(data.item)"
                >
                    <fa icon="check"></fa>
                    참여자 보기
                </b-button>
            </template>

            <template #cell(status)="data">
                <b-button size="sm" variant="dark-border"
                          @click="enterProject('project', data.item, 'ProjectProgress')"
                >
                    <fa icon="check"></fa>
                    확인하기
                </b-button>
            </template>
        </b-table>


        <AssessmentMemberModal ref="assessment-member-modal"
                               :selected_company="selected_company"
                               :read-only="readOnly"
        />
    </b-card>
</template>


<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import assessmentCommonMixin from '@shared/mixin/assessment.common.mixin';
import { companyRequestColumn } from '@shared/components/admin/pages/Management/Company/data';
import {getEmptyTableHTML} from '@shared/components/admin/pages/Management/common-data';
import AssessmentMemberModal from './AssessmentMemberModal.vue';

export default  {
    name: 'AdminCompanyAssessmentInfo',
    components: {
        fa: FontAwesomeIcon,
        AssessmentMemberModal
    },
    mixins: [
        assessmentCommonMixin  
    ],
    props: {
        selected_company: {
            type: Object,
            default: () => ({})
        },
        readOnly: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        getEmptyTableHTML() {
            return getEmptyTableHTML('조회된 평가 정보가 없습니다.', '521px');
        },
        companyRequestColumn() {
            return companyRequestColumn.map(column => {
                column.label = this.$t(column.label);
                return column;
            });
        },
    },
    methods: {
        manageProjectMember (project) {
            this.$refs['assessment-member-modal'].manageProjectMember(project);
        },
        async enterProject(admin, project, mode) {
            this.$router.push({ name: mode, query: { client: project.client, pc: project.project_code, cmp: project.campaign_id, admin_mode: admin  } });
        },
    }
};
</script>
